#import "./ParashahDetails.graphql"
fragment haftarahDetails on HaftarahType {
  reading {
    id
    user {
      username
    }
  }
  section
  variant
  comment
  year
  parashah {
    ...parashahDetails
  }
}
